export async function poll<TResult>(functionToCall: () => Promise<TResult>, evaluationFunction: (result: TResult) => boolean, retryIntervalMs: number = 100, timeoutInMs: number = 250): Promise<TResult> {
    let result: TResult;

    const throwTimeout = new Promise<TResult>((resolve) => {
        setTimeout(() => {
            resolve(result);
        }, timeoutInMs);
    });
    const getResult = new Promise<TResult>(async (resolve) => {
        result = await functionToCall();
        while (!evaluationFunction(result)) {
            result = await new Promise((resolveRetry) => {
                setTimeout(() => {
                    resolveRetry(functionToCall())
                }, retryIntervalMs)
            });
        }
        return resolve(result);
    });
    return Promise.race([throwTimeout, getResult]);
}